import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator, enableIndexedDbPersistence } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDomls_efRHrRFSmbaqP-qVd5N1McMX368",
  authDomain: "flow-climbing.firebaseapp.com",
  projectId: "flow-climbing",
  storageBucket: "flow-climbing.appspot.com",
  messagingSenderId: "845131771941",
  appId: "1:845131771941:web:89adbab1066e87afa04fcc",
  measurementId: "G-GW5J21Z389"
};
export const firebaseApp = initializeApp(firebaseConfig);
export const analytics = getAnalytics(firebaseApp);

if(window.location.hostname==="localhost"){
  connectAuthEmulator(getAuth(),"http://localhost:9099")
  connectFirestoreEmulator(getFirestore(), 'localhost', 8080);
}
enableIndexedDbPersistence(getFirestore())
  .catch((err) => {
      console.error(err)
  });
// Initialize Firebase
